/**
 * Mirrors FeVisitLifecycleService::TRANSITIONS from-lists for admin UI gating.
 * Keep in sync with actionlabs-services/app/Services/Mobile/FeVisitLifecycleService.php.
 */

/** TRANSITIONS['cancel']['from'] */
export const FE_VISIT_CANCEL_FROM = [
  'fe_visit_pending',
  'fe_visit_accepted',
  'fe_visit_eta_submitted',
  'fe_visit_en_route',
  'fe_visit_arrived',
  'fe_visit_in_progress',
  'fe_visit_issue_with_documents',
  'fe_visit_revisit',
] as const

/** TRANSITIONS['markClosed']['from'] */
export const FE_VISIT_MARK_CLOSED_FROM = [
  'fe_visit_resolved',
  'fe_visit_in_progress',
  'fe_visit_arrived',
  'fe_visit_issue_with_documents',
] as const

export function canCancelFeVisit(status?: string | null): boolean {
  const code = (status ?? '').trim()
  return (FE_VISIT_CANCEL_FROM as readonly string[]).includes(code)
}

export function canForceCloseFeVisit(status?: string | null): boolean {
  const code = (status ?? '').trim()
  return (FE_VISIT_MARK_CLOSED_FROM as readonly string[]).includes(code)
}
